import { render, staticRenderFns } from "./QueryByHand.vue?vue&type=template&id=a828432e&scoped=true"
import script from "./QueryByHand.vue?vue&type=script&lang=js"
export * from "./QueryByHand.vue?vue&type=script&lang=js"
import style0 from "./QueryByHand.vue?vue&type=style&index=0&id=a828432e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a828432e",
  null
  
)

export default component.exports